export const environment = {
  production: true,
  rootUrl: 'https://jmte.kr',
  s3: {
    bucketname: 'jmt',
  },
};
